import httpManager from "@/app/shared/utils/httpManager";
/**
 * Obtener todos los usuarios registrados.
 *
 * @return {Promise<Array>} Lista de usuarios.
 */
export default async function (limit = 120) {
  const response = await httpManager.get(`/users/active/?limit=${limit}&offset=0`);
  return response?.data?.results;
}
